import rules from '../web-sh/src/config/rules';
import { Trans } from 'react-i18next'
import PATTERNS from './patterns';

const INVALID = (name = '', pattern = '', message = '') => {
  return {
    pattern: PATTERNS[pattern],
    message: message || <Trans i18nKey='validation.invalid' values={{ name: name }}/>
  }
}

rules.INVALID = INVALID;

export default {
  ...rules,
  LIMIT_LENGTH: (min = 0, max = 1, message = '') => {
    return {
      min: min,
      max: max,
      type: 'string',
      message: message
    }
  },
};
